import * as types from './types';

/*
Functions that immediately return an action or array of actions
 */

// allTickets is of the form {
export const hydrateAllTickets = (allTickets) => ({
  type: types.HYDRATE_ALL_TICKETS,
  tickets: allTickets,
});

export const hydrateNominatedTickets = (nominatedTickets) => ({
  type: types.HYDRATE_NOMINATED_TICKETS,
  nominatedTickets,
});

export const hydrateReviewTickets = (reviewTickets) => ({
  type: types.HYDRATE_REVIEW_TICKETS,
  reviewTickets,
});

export const hydrateAssignedTickets = (assignedTickets) => ({
  type: types.HYDRATE_ASSIGNED_TICKETS,
  assignedTickets,
});

export const hydrateExperts = (experts) => {
  return {
    type: types.HYDRATE_EXPERTS,
    experts,
  };
};

// keeps any existing expert attributes, but overrides with new ones
// creates expert if it doesn't exist
export const updateExpert = (expert) => ({
  type: types.UPDATE_EXPERT,
  expert,
});

export const updateOwnAvailability = (availability) => ({
  type: types.UPDATE_OWN_AVAILABILITY,
  availability,
});

// does not load data unlike selectInboxTab()
export const changeTab = (tabName) => ({
  type: types.CHANGE_TAB,
  tabName,
});

// opens conversation in right pane
// defaults to blank conversation
// side effects: turns on middleware
export const showConversation = (conversation = { allMessages: [], selectedConversationId: '' }) => ({
  type: types.SHOW_CONVERSATION,
  conversation,
});

export const hydrateBusinessesDetailsPage = (payload) => {
  return {
    type: types.HYDRATE_BUSINESSES_DETAILS_PAGE,
    payload,
  };
};

export const hydrateBusinessesDetailsList = (businessesDetails) => {
  return {
    type: types.HYDRATE_BUSINESSES_DETAILS_LIST,
    payload: businessesDetails,
  };
};

export const hydrateExpertsForForwardingDropdown = (experts, cursor) => {
  return {
    type: types.HYDRATE_EXPERTS_FOR_FORWARDING_DROPDOWN,
    experts,
    cursor,
  };
};

export const lockConversation = (conversationId) => ({
  type: types.LOCK_CONVERSATION,
  conversationId,
});

export const unlockConversation = (conversationId) => ({
  type: types.UNLOCK_CONVERSATION,
  conversationId,
});

export const setMlOrdersIds = (ticketId, ordersObject) => ({
  type: types.SET_ML_ORDERS_IDS,
  ticketId,
  ordersObject,
});

export const setRecommendedProductsForPartner = (data, ticketId) => ({
  type: types.SET_RECOMMENDED_PRODUCTS_FOR_PARTNER,
  data,
  ticketId,
});

export const setRecommendationAsPreviouslyTriggered = (ticketId) => ({
  type: types.SET_RECOMMENDATION_AS_PREVIOUSLY_TRIGGERED,
  ticketId,
});

export const clearToolsRbiStore = () => ({
  type: types.CLEAR_TOOLS_RBI_STORE,
});

export const clearToolsRbiCustomerStore = () => ({
  type: types.CLEAR_TOOLS_RBI_CUSTOMER_STORE,
});
